module.exports = __webpack_public_path__ + "img/gesplanos5.3035f59f.png";